module.exports = __webpack_public_path__ + "static/img/AM.35d29641.png";